module.exports = __webpack_public_path__ + "img/pexels-photo-220455@2x.015f896e.png";